import { Skeleton } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export const CardListSkeleton = ({
  isLoading,
  children,
  quantity = 4,
}: PropsWithChildren<{ isLoading: boolean; quantity?: number }>) => {
  return isLoading ? (
    Array.from({ length: quantity }).map((_, index) => (
      <Skeleton key={index} height="200px" w="full" />
    ))
  ) : (
    <>{children}</>
  );
};
